/**
 * Reference data hooks.
 *
 * Plan D8 allows React Query and no other state library: server data is cached
 * here, and component state stays in components. There is no Redux store, and
 * there should not be one.
 *
 * Reference values are configuration, not transactional data — they change when a
 * member of staff edits them in NocoDB, which is rare. A long `staleTime` keeps
 * every form from refetching the same forty rows.
 */

import { useQuery } from '@tanstack/react-query';
import type { ReferenceCategory } from '@parinaam-vms/shared';
import {
  fetchReferenceValues,
  fetchReferenceValuesGrouped,
} from '../services/api/reference-values';

const REFERENCE_STALE_TIME_MS = 10 * 60 * 1000;

import { referenceKeys } from './queryKeys';

export { referenceKeys };

export function useReferenceValues(category?: ReferenceCategory) {
  return useQuery({
    queryKey: category ? referenceKeys.byCategory(category) : referenceKeys.all,
    queryFn: () => fetchReferenceValues(category),
    staleTime: REFERENCE_STALE_TIME_MS,
  });
}

export function useReferenceValuesGrouped() {
  return useQuery({
    queryKey: referenceKeys.grouped,
    queryFn: fetchReferenceValuesGrouped,
    staleTime: REFERENCE_STALE_TIME_MS,
  });
}
